import type { FaireProductEntity } from "../../entity_types/product";

export const p_sxjw4pr3v2: FaireProductEntity = {
  token: "p_sxjw4pr3v2",
  type: "product",
  name: "Yiayia and Friends Extra Virgin Olive Oil w/ Chili Pepper",
  brandToken: "b_7zvy8vlx5g",
  brandName: "Hellenic Farms",
  imageUrl:
    "https://cdn.faire.com/fastly/958b63ee76666b0280650779b05e4abbb1ae0309990b024e61a21f1c5c19de2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d441ffec6d71bcd07ee51d99f466f9535d6530a7cc4e4c09e6080121948030f.jpeg",
    "https://cdn.faire.com/fastly/2efd7b705cc18f3310fe4475364fe2a663371826a95485a9e5538e281d56510e.jpeg",
  ],
  priceDollars: 18,
  description:
    "This is a story about YIAYIA. A Greek granny together with her animal friends spreads the message of family values through food related stories and experiences conceptualized with a fresh perspective and a sense of humor. Premium quality extra virgin olive oil, cold-pressed, flavored w/ chili peppers for added spiciness and piquant savor!\nPackaging: 200mL dark glass bottle",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:58.221Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
